// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/copy-plus.js';

import { paths } from '../generated/copy-plus';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('copy-plus', Original, paths);
